export default function validateOnlyLetters(fullName) {
  if (fullName) {
    const regexToOnlyLetters = new RegExp('^[.\\p{L}]*$', 'gmiu');
    const fullNameWithoutSpaces = fullName.replace(/\s+/g, '');
    return regexToOnlyLetters.test(fullNameWithoutSpaces);
  }
  return true;
}
